import { render, staticRenderFns } from "./QuickAssignment.vue?vue&type=template&id=28e63939"
import script from "./QuickAssignment.vue?vue&type=script&lang=js"
export * from "./QuickAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28e63939')) {
      api.createRecord('28e63939', component.options)
    } else {
      api.reload('28e63939', component.options)
    }
    module.hot.accept("./QuickAssignment.vue?vue&type=template&id=28e63939", function () {
      api.rerender('28e63939', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/expenses/QuickAssignment.vue"
export default component.exports